function StaticSpcStepper() {
  return (
    <div className="w-[320px] flex-shrink-0 md:pr-12">
      <p className="text-22px font-semibold text-neutral-800 mb-4">
        Service Purchase Calculator
      </p>

      <div className="space-y-2 mt-[20px]">

        {/* ---------- STEP 1 (Active) ---------- */}
        <div className="relative">
          {/* connector line */}
          <div className="absolute left-5 top-4 h-full w-[1.5px] bg-[#B3B3B3]" />
          <div className="rounded-lg px-2 py-2 text-base w-full text-left">
            <span className="flex items-start">
             <span className="relative flex h-6 w-6 items-center justify-center bg-white rounded-full">
                <div className="h-full w-full border-[#B3B3B3] border-2 rounded-full"></div>
              </span>
              <span className="ml-3 text-15px font-semibold text-gray-400">
                Service Type
              </span>
            </span>
          </div>
        </div>

        {/* ---------- STEP 2 ---------- */}
        <div className="relative">
          <div className="absolute left-5 top-4 h-full w-[1.5px] bg-[#B3B3B3]" />
          <div className="rounded-lg px-2 py-2 text-base w-full text-left">
            <span className="flex items-start">
              <span className="relative flex h-6 w-6 items-center justify-center bg-white rounded-full">
                <div className="h-full w-full border-[#B3B3B3] border-2 rounded-full"></div>
              </span>

              <span className="ml-3 text-15px font-semibold text-gray-400">
                About Estimate
              </span>
            </span>
          </div>
        </div>

        {/* ---------- STEP 3 ---------- */}
        <div className="relative">
          <div className="absolute left-5 top-4 h-full w-[1.5px] bg-[#B3B3B3]" />

          <div className="rounded-lg px-2 py-2 text-base w-full text-left">
            <span className="flex items-start">
              <span className="relative flex h-6 w-6 items-center justify-center bg-white rounded-full">
                <div className="h-full w-full border-[#B3B3B3] border-2 rounded-full"></div>
              </span>

              <span className="ml-3 text-15px font-semibold text-gray-400">
                Enter Details
              </span>
            </span>
          </div>
        </div>

        {/* ---------- STEP 4 ---------- */}
        <div className="relative">
          <div className="absolute left-5 top-4 h-full w-[1.5px] bg-[#B3B3B3]" />

          <div className="rounded-lg px-2 py-2 text-base w-full text-left">
            <span className="flex items-start">
              <span className="relative flex h-6 w-6 items-center justify-center bg-white rounded-full">
                <div className="h-full w-full border-[#B3B3B3] border-2 rounded-full"></div>
              </span>

              <span className="ml-3 text-15px font-semibold text-gray-400">
                Summary
              </span>
            </span>
          </div>
        </div>

        {/* ---------- STEP 5 ---------- */}
        <div className="relative">
          {/* last item — no connector */}
          <div className="rounded-lg px-2 py-2 text-base w-full text-left">
            <span className="flex items-start">
              <span className="relative flex h-6 w-6 items-center justify-center bg-white rounded-full">
                <div className="h-full w-full border-[#B3B3B3] border-2 rounded-full"></div>
              </span>

              <span className="ml-3 text-15px font-semibold text-gray-400">
                Estimate
              </span>
            </span>
          </div>
        </div>

      </div>
    </div>
  );
}

export default StaticSpcStepper;